// Reserved words that cannot be used as short codes
export const RESERVED_WORDS = [
  // Admin & System
  'admin', 'administrator', 'root', 'system', 'config', 'settings',
  'dashboard', 'panel', 'control', 'manage', 'manager',
  
  // API & Technical
  'api', 'rest', 'graphql', 'webhook', 'callback', 'oauth', 'auth',
  'login', 'logout', 'signin', 'signup', 'register',
  
  // Common Pages
  'home', 'index', 'main', 'www', 'web', 'site', 'page',
  'about', 'contact', 'help', 'support', 'faq', 'terms',
  'privacy', 'policy', 'legal', 'disclaimer',
  
  // Content Management
  'blog', 'news', 'article', 'post', 'content', 'media',
  'upload', 'download', 'file', 'files', 'asset', 'assets',
  'image', 'images', 'img', 'photo', 'photos', 'pic', 'pics',
  
  // User Management
  'user', 'users', 'profile', 'account', 'member', 'members',
  
  // Common Subdomains
  'mail', 'email', 'ftp', 'ssh', 'ssl', 'cdn', 'static',
  'dev', 'test', 'staging', 'beta', 'alpha', 'demo',
  
  // Database & Storage
  'db', 'database', 'sql', 'mysql', 'postgres', 'mongo',
  'redis', 'cache', 'storage', 'backup',
  
  // Monitoring & Analytics
  'stats', 'analytics', 'metrics', 'monitor', 'log', 'logs',
  'error', 'errors', 'debug', 'trace',
  
  // Security
  'security', 'secure', 'ssl', 'tls', 'cert', 'certificate',
  'firewall', 'proxy', 'vpn',
  
  // Common Short Codes
  'url', 'link', 'short', 'tiny', 'mini', 'go', 'redirect',
  'r', 'l', 's', 't', 'u', 'x', 'z',
  
  // Social Media
  'facebook', 'twitter', 'instagram', 'linkedin', 'youtube',
  'whatsapp', 'telegram', 'tiktok', 'snapchat',
  
  // Islamic Terms (for NurulQuran context)
  'quran', 'hadith', 'islam', 'muslim', 'allah', 'prophet',
  'mosque', 'prayer', 'salah', 'ramadan', 'hajj', 'umrah',
  
  // Generic Terms
  'test', 'sample', 'example', 'demo', 'temp', 'tmp',
  'null', 'undefined', 'void', 'none', 'empty', 'blank'
];

export const isReservedWord = (word) => {
  return RESERVED_WORDS.includes(word.toLowerCase());
};

export const validateShortCode = (shortCode) => {
  if (!shortCode || shortCode.length < 2) {
    return { valid: false, message: 'Short code must be at least 2 characters long' };
  }
  
  if (shortCode.length > 20) {
    return { valid: false, message: 'Short code must be less than 20 characters' };
  }
  
  if (!/^[a-zA-Z0-9-_]+$/.test(shortCode)) {
    return { valid: false, message: 'Short code can only contain letters, numbers, hyphens, and underscores' };
  }
  
  if (isReservedWord(shortCode)) {
    return { valid: false, message: 'This short code is reserved and cannot be used' };
  }
  
  return { valid: true };
};